import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import Services from "./components/services/Services";
import { Suspense, lazy } from "react";
import { FaCartPlus } from "@react-icons/all-files/fa/FaCartPlus";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { FaStar } from "@react-icons/all-files/fa/FaStar";
import body from "../../../../assets/image/category/Body.webp";
import bracks1 from "../../../../assets/image/category/bracks1.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import { FaChevronLeft } from "@react-icons/all-files/fa/FaChevronLeft";
import { FaChevronRight } from "@react-icons/all-files/fa/FaChevronRight";
import fluid from "../../../../assets/image/category/fluid.webp";
import radiators from "../../../../assets/image/category/radiators.webp";
import maintenance from "../../../../assets/image/category/maintenance.webp";
import electricalproblem from "../../../../assets/image/services/electricalproblem.webp";
import image from "../../../../assets/image/category/image.webp";
import { FaPhone, FaArrowRightLong, FaXTwitter } from "react-icons/fa6";
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import { FaMapMarkerAlt } from "@react-icons/all-files/fa/FaMapMarkerAlt";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { FaMinusCircle } from "@react-icons/all-files/fa/FaMinusCircle";
import { CiStar } from "react-icons/ci";
import hero_banner from "../../../../assets/image/heroBanner.webp";
import mobile_banner from "../../../../assets/image/mobileBanner.webp";
import mobile_hero_image from "../../../../assets/image/mobileBanner.webp";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  getMakeDataAPi,
  getModelDataAPi,
  getPartListDataAPi,
  getProductDataAPi,
  getYearDataAPi,
} from "../../../redux/reduxApi/website/MakeYearModel";
import MyButton from "../utils/Button/MyButton";
import { Spinner } from "@chakra-ui/react";
import { X } from "lucide-react";
import { IoSearch } from "@react-icons/all-files/io5/IoSearch";
import CryptoJS from "crypto-js";
import { getCustomerByUserId } from "../../../redux/reduxApi/SingIn&SingUp/SingUpApi";
import { logout, setCatalystUser } from "../../../redux/reduxSlice/SingIn&Singup/SingInSlice";
import FeaturedCategories from "./components/featuredCategories/FeaturedCategories";
import { AddCustomerApi, checkCustomerEmail } from "../../../redux/reduxApi/admin/CustomerReduxApi";
import { cartProductCount } from "../../../redux/reduxApi/website/CartProductCount";
import { getWishlistCount } from "../../../redux/reduxApi/website/WishlistApi";

const TestimonialSlider = lazy(() => import("./components/slider/TestimonialSlider"));
const Blogs = lazy(() => import("./components/blogs/Blogs"));
const SliderLazy = lazy(() => import("./components/slider/Slider"));




const SERVICES = [
  {
    title: "Brake",
    image: bracks1,
    link: "/breaks",
  },
  {
    title: "Clutch & Transmissions",
    image: image,
    link: "/clutch",
  },
  {
    title: "Maintenance",
    image: maintenance,
    link: "/maintenance",
  },
  {
    title: "Fuel",
    image: fluid,
    link: "/fuel",
  },
  {
    title: "Electrical",
    image: electricalproblem,
    link: "/electrical",
  },
  {
    title: "Radiators & Cooling",
    image: radiators,
    link: "/radiators",
  },
];


const SECRET_KEY = "6454gfdydt46465";

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data.toString(), SECRET_KEY).toString();
};

export const decryptData = (cipherText) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};


function HomePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const { getYearData: yearOptions } = useSelector((state) => state.MakeYearModel);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const [user, setUser] = useState(null); // null = not logged in

  // Lazy load Blogs section when scrolled into view
  const [isBlogsVisible, setIsBlogsVisible] = useState(false);
  const blogsRef = useRef(null);
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const sliderRef = useRef(null);
  const [isTestimonialVisible, setIsTestimonialVisible] = useState(false);
  const testimonialRef = useRef(null);
  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Intersection Observer for lazy loading Blogs section
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isBlogsVisible) {
          setIsBlogsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (blogsRef.current) {
      observer.observe(blogsRef.current);
    }

    return () => {
      if (blogsRef.current) {
        observer.unobserve(blogsRef.current);
      }
    };
  }, [isBlogsVisible]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isSliderVisible) {
          setIsSliderVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 } // adjust if needed
    );

    if (sliderRef.current) {
      observer.observe(sliderRef.current);
    }

    return () => {
      if (sliderRef.current) {
        observer.unobserve(sliderRef.current);
      }
    };
  }, [isSliderVisible]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isTestimonialVisible) {
          setIsTestimonialVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 } // adjust if needed
    );

    if (testimonialRef.current) {
      observer.observe(testimonialRef.current);
    }

    return () => {
      if (testimonialRef.current) {
        observer.unobserve(testimonialRef.current);
      }
    };
  }, [isTestimonialVisible]);

  useEffect(() => {
    if (yearOptions.length == 0) {
      dispatch(getYearDataAPi());
    }
  }, [dispatch]);

  // // make module years
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedMake, setSelectedMake] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const [loadingMake, setLoadingMake] = useState(false);
  const [loadingModel, setLoadingModel] = useState(false);

  // Part number search states
  const [searchPartNum, setSearchPartNum] = useState("");
  const [partNoLoading, setPartNoLoading] = useState(false);
  const [clearPartNo, setClearPartNo] = useState(false);

  const handleMakeChange = useCallback(async (event) => {
    const selectedMake = event.target.value;
    // console.log("this is selected make", selectedMake);
    setSelectedMake(selectedMake);
    // Clear model when make changes to ensure clean state
    setSelectedModel("");
    setModelOptions([]);
    setLoadingModel(true);
    getModelDataAPi({ selectedYear, selectedMake }).then((res) => {
      if (res) {
        setModelOptions(res);
      }
    }).finally(() => {
      setLoadingModel(false);
    })

  }, [selectedYear]);


  useEffect(() => {
    let cancelled = false;
    let intervalId;

    const initAuth = async () => {
      if (!window.catalyst) return; // still not loaded, polling will retry

      setIsLoadingUser(true);
      try {
        const response = await window.catalyst.userManagement.getCurrentProjectUser();
        console.log("Checking user homepage authentication status...", response);
        if (cancelled) return;

        if (response?.content?.is_confirmed) {
          const {
            user_id,
            first_name,
            last_name,
            email_id,
          } = response.content;

          const userData = {
            userId: user_id,
            firstName: first_name,
            lastName: last_name,
            email: email_id,
            isConfirmed: true,
            raw: response.content,
          };
          if (response.content.source === "Google") {
            try {
              const emailCheck = await dispatch(checkCustomerEmail({ email: response.content.email_id }));
              console.log("checkCustomerEmail response ", emailCheck);
              if (!emailCheck.payload.data.success) {
                const resp = await dispatch(AddCustomerApi({ firstName: response.content.first_name, lastName: response.content.last_name, email: response.content.email_id, userId: response.content.user_id, isVerified: response.content.is_confirmed, orgId: response.content.org_id }));
                console.log("AddCustomerApi response:", resp);
              }
            } catch (err) {
              console.error("Error in Google login flow: ", err);
            }
          }
          setUser(userData);
          dispatch(setCatalystUser(userData));
          localStorage.setItem("catalystUser", JSON.stringify(userData));

          const encrypted = encryptData(user_id);
          localStorage.setItem("authToken", encrypted);
          localStorage.setItem("userId", user_id);
          localStorage.setItem("firstName", first_name);
          localStorage.setItem("lastName", last_name);
          localStorage.setItem("email", email_id);

          window.dispatchEvent(new Event('appUserLoggedIn'));

        } else {
          // user not confirmed – redirect to login
          setUser(null);
          localStorage.removeItem("catalystUser");
          localStorage.removeItem("customerId");
          dispatch(logout());
          window.location.href = "/login";
        }
      } catch (err) {
        console.error("Error fetching Catalyst user:", err);
        setUser(null);
        localStorage.removeItem("catalystUser");
      } finally {
        if (!cancelled) {
          setIsLoadingUser(false);
        }
      }
    };

    // poll until catalyst is ready, then run once
    if (window.catalyst) {
      initAuth();
    } else {
      intervalId = setInterval(() => {
        if (window.catalyst) {
          clearInterval(intervalId);
          initAuth();
        }
      }, 500);
    }

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, []);
  useEffect(() => {
    const syncCustomer = async () => {
      if (!user?.userId) return; // no user yet, nothing to sync

      try {
        const res = await dispatch(getCustomerByUserId({ id: user.userId }));
        // console.log("Customer sync response:", res);

        if (res?.payload?.success) {
          const customerId = res.payload?.customer?.ROWID;
          if (customerId) {
            localStorage.setItem("customerId", customerId);
             dispatch(cartProductCount(customerId));
             dispatch(getWishlistCount(customerId));
          }
          // console.log("Customer data sync successful", customerId);
        } else {
          console.warn("Customer API failed:", res);
        }
      } catch (err) {
        console.error("Error fetching customer:", err);
      }
    };

    syncCustomer();
  }, [user?.userId, dispatch,]);


  const handleModelChange = useCallback(async (event) => {
    const selectedModel = event.target.value;
    setSelectedModel(selectedModel);

    getProductDataAPi({ selectedYear, selectedMake, selectedModel }).then((res) => {
      if (res) {
        setCategoryOptions(res);
      }
    })


  }, [selectedYear, selectedMake]);

  const handleYearChange = useCallback(async (event) => {
    const years = event.target.value;
    setSelectedYear(event.target.value);
    // Clear make and model when year changes to ensure clean state
    setSelectedMake("");
    setSelectedModel("");
    setMakeOptions([]);
    setModelOptions([]);
    setLoadingMake(true)
    getMakeDataAPi(years).then((res) => {
      if (res) {
        setMakeOptions(res);
      }
    }).finally(() => {
      setLoadingMake(false);
    })
    //   console.log("this is make  data", response);
    //   const makeData = response.payload.ShowMeTheParts_Make.make.map(
    //     (make) => ({
    //       value: make.id,
    //       label: make.data,
    //     })
    //   );

    //   setMakeOptions(makeData);

  }, []);

  // Part number search functions
  const handlePartNumSearch = useCallback(() => {
    if (searchPartNum.trim()) {
      navigate(
        `/shop?partNumber=${encodeURIComponent(searchPartNum.trim())}`
      );
    }
  }, [searchPartNum, navigate]);

  const handleClearPartNo = useCallback(() => {
    setSearchPartNum("");
    setClearPartNo(false);
  }, []);

  return (
    <div>
      <main className="overflow-hidden">
        <div className="flex-1  relative  w-full ">
          <div>
            <img
              src={hero_banner}
              alt="Jump Starters"
              className="w-full h-[30rem]  object-cover  hidden md:block"
            />
            <img
              src={mobile_banner}
              alt="Jump Starters"
              className="w-full object-cover  block md:hidden text-center h-[400px]"
              style={{ marginTop: 0 }}
            />
            <div className="absolute flex lg:ml-24 md:ml-[57px] ml-1 inset-0 flex-col justify-center lg:h-[64%] md:h-[66%] h-[50%]   text-white space-y-2 lg:px-2 px-2  md:w-1/2 lg:w-1/2 w-full">
              <h1
                className={`text-[1.7rem] lg:text-5xl md:text-4xl font-bold 
                transition-all duration-[700ms] ease-out
                ${isVisible
                    ? "translate-x-0 opacity-100"
                    : "-translate-x-10 opacity-0"
                  }
              `}
              >
                Transform Your Ride with Premium Parts
              </h1>
              {/* <p className="text-lg py-2 mb-3">Upgrade your vehicle with high-quality, premium parts for superior performance and style.</p> */}
              {/* <p className="text-lg">Up to 45% Off</p> */}
              <p
                className={`
                transition-all duration-[900ms] lg:text-2xl text-[1.4rem] ease-out py-2 
                ${isVisible
                    ? "translate-x-0 opacity-100"
                    : "-translate-x-10 opacity-0"
                  }
              `}
              >
                Upgrade your vehicle with high-quality, premium parts for
                performance and style
              </p>
              <div
                className={`
                transition-all duration-[3000ms] ease-out
                ${isVisible ? " opacity-100" : " opacity-0"}
              `}
              >
                <Link to="/shop">
                  {/* <button className="bg-orange-500 text-white px-4 py-2 rounded-full flex gap-2 items-center text-lg font-bold">
                Shop now <FaLongArrowAltRight />
              </button> */}
                  <MyButton text="Shop Now" />
                </Link>
              </div>
            </div>
          </div>

          <div
            className="lg:p-[19px] md:p-[27px] p-[12px]  shadow-md  drop-shadow-md lg:w-[83%] md:w-[85%] w-[94%] mx-auto  flex my-10  bg-white border-2 border-gray-200"
            style={{ borderRadius: "25px" }}
          >

            <div className="w-100 text-center py-2 ">
              <h1 className="text-3xl lg:text-4xl md:text-4xl font-bold text-blue-900 ">
                Select Your Vehicle
              </h1>
              <p className="text-xl">
                Over 300,000 auto parts and accessorries
              </p>

              <div className=" p-3 flex justify-center items-center gap-2">

                <div className=" flex items-center rounded-full border border-gray-400 bg-white ps-3 pe-2 lg:w-1/3 w-full relative">
                  <IoSearch size="25px" color="orange" />
                  <input value={searchPartNum} onChange={(e) => { setSearchPartNum(e.target.value); setClearPartNo(e.target.value.trim() !== ""); }} onKeyDown={(e) => { if (e.key === 'Enter') handlePartNumSearch(); }} type="text" placeholder="Search Part Number" className="px-1 py-2 bg-transparent text-gray-500 focus:outline-none w-full"
                  />
                  {partNoLoading && <Spinner size="sm" className="me-2" />}
                  {clearPartNo && <X onClick={handleClearPartNo} className="rounded-full me-1" colorScheme="blue" />}
                </div>
                {searchPartNum !== "" && <div isLoading={partNoLoading} onClick={handlePartNumSearch} className="rounded-pill bg-white border p-2.5"><IoSearch className="" size="22px" color={partNoLoading ? "gray" : "blue"} /></div>}
                {/* <div className=" flex items-center rounded-full border border-gray-400 bg-white ps-3 pe-2 lg:w-1/3 w-full relative">
                            <IoSearch size="25px" color="orange" />
                            <input value={searchPartNum} onChange={(e) => setSearchPartNum(e.target.value)} type="text" placeholder="Search Part Number" className="px-1 py-2 bg-transparent text-gray-500 focus:outline-none w-full"
                            />{searchPartNum !== "" && <Button isLoading={partNoLoading} onClick={handlePartNumSearch} variant={'solid'} borderRadius={'full'} className="rounded-full" colorScheme="blue" ><IoSearch className="" size="25px" color="white" /></Button>}
                            {clearPartNo && <Button onClick={handleClearPartNo} variant={'solid'} borderRadius={'full'} className="rounded-full" colorScheme="blue" >Clear</Button>}
                          </div> */}
              </div>

              <div className="lg:flex md:flex justify-between ">
                <div className="w-full lg:w-11/12 md:w-11/12 mx-auto ">
                  <div className="lg:flex md:flex gap-2 px-1 lg:p-2 ">
                    <select
                      value={selectedYear}
                      onChange={handleYearChange}
                      className="border-2 border-blue-900  p-2 my-1 rounded w-full"
                    >
                      <option value="">Year</option>
                      {(yearOptions || []).map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <select
                      value={selectedMake}
                      onChange={handleMakeChange}
                      className="border-2 border-blue-900 p-2 my-1 rounded w-full"
                      disabled={!selectedYear}
                    >
                      <option value="">{loadingMake ? "Loading..." : "Make"}</option>
                      {(makeOptions || []).map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <select
                      value={selectedModel}
                      onChange={handleModelChange}
                      className="border-2 border-blue-900  p-2 my-1 rounded w-full"
                      disabled={!selectedMake}
                    >
                      <option value="">{loadingModel ? "Loading..." : "Model"}</option>
                      {(modelOptions || []).map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="lg:flex md:flex gap-2  px-2 lg:p-2">
                    <select className="border-2 border-blue-900  p-2 my-1 rounded w-full">
                      <option value="">Category</option>
                      {modelOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <select className="border-2 border-blue-900  p-2 my-1 rounded w-full">
                      <option value="">Part Type</option>
                      {modelOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <select className="border-2 border-blue-900  p-2 my-1 rounded w-full">
                      <option value="">Engine Part</option>
                      {modelOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </div>
                <div className="w-full lg:w-1/12 md:w-1/12  mx-2   lg:flex md:flex items-center  ">
                  <button
                    className="bg-orange-500 rounded px-3 py-2  text-white font-bold  hover:bg-[#034C8C]"
                    onClick={() => {
                      if (!selectedYear || !selectedMake || !selectedModel) {
                        toast.error("Please select Year, Make, and Model");
                        return;
                      }
                      // navigate only, don't trigger Shop search button automatically
                      navigate(
                        `/shop/vehicles/${selectedMake}/${selectedModel}/${selectedYear}`,
                        { state: { skipSearcsh: true } }
                      );
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>


      <FeaturedCategories />
      {/* services */}
      <div className="py-[50px] lg:py-[50px] md:px-[7%] md:py-[50px]">
        <div className="container mx-auto lg:px-4 md:px-4 px-2 text-center">
          <h1 className="lg:text-5xl md:text-5xl text-3xl font-bold text-blue-900 pb-3 ">
            Featured Services
          </h1>
          <hr className="heading-seperator border-4 border-orange-600" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 pb-3">
            {SERVICES.map((service, index) => (
              <div className="relative overflow-hidden rounded-lg" key={index}>
                <img
                  src={service.image}
                  onClick={() => navigate(`${service.link}`)}
                  alt="Collection One"
                  className="w-full h-[250px] object-cover rounded"
                  loading="lazy"
                />
                <div
                  onClick={() => navigate(`${service.link}`)}
                  className="absolute top-0 left-0 bottom-0 cursor-pointer right-0 rounded-lg bg-gray-600   bg-opacity-50 flex flex-col justify-end transition-all duration-300
                  sm:opacity-100 sm:translate-y-10 
                  md:opacity-0 md:translate-y-10 
                  md:hover:opacity-100 md:hover:translate-y-0 pb-4"
                >
                  <h4 className="text-white">{service.title}</h4>
                  <Link to={`${service.link}`}>
                    <MyButton
                      text="Read More"
                      className="mx-auto hover:scale-105"
                    />
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <Link to="/our-services">
            {/* <button className="bg-orange-500 text-white px-4 py-2 rounded-full flex gap-2 items-center text-lg sm:text-xl lg:text-lg font-bold mx-auto">
              View More <FaLongArrowAltRight />
            </button> */}
            <MyButton
              text="View More"
              className="mx-auto mt-7 hover:scale-105"
            />
          </Link>
        </div>
      </div>


      <div ref={testimonialRef}>
        {isTestimonialVisible && (
          <Suspense fallback={null}>
            <TestimonialSlider />
          </Suspense>
        )}
      </div>
      <div ref={blogsRef}>
        {isBlogsVisible && (
          <Suspense fallback={null}>
            <Blogs />
          </Suspense>
        )}
      </div>
      {/* slider */}
      <div ref={sliderRef}>
        {isSliderVisible && (
          <Suspense fallback={null}>
            <SliderLazy />
          </Suspense>
        )}
      </div>
    </div>
  );
}

export default HomePage;